import { api } from "./api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Blog cover images are returned as relative /api/blog/image/... paths;
// prepend the backend origin so <img> resolves them correctly.
export const blogImageUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//.test(path)) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};

export const fetchBlogPosts = (params = {}) =>
  api.get("/blog", { params }).then((r) => r.data);

export const fetchBlogCategories = () =>
  api.get("/blog/categories").then((r) => r.data);

export const fetchBlogPost = (slug) =>
  api.get(`/blog/${slug}`).then((r) => r.data);

export const subscribeNewsletter = (email, source = "blog") =>
  api.post("/blog/subscribe", { email, source }).then((r) => r.data);

// Admin
export const adminListBlog = (status = "all") =>
  api.get("/blog/admin/list", { params: { status } }).then((r) => r.data);

export const adminGenerateBlog = (count = 3) =>
  api.post("/blog/admin/generate", { count }).then((r) => r.data);

export const adminBlogStatus = () =>
  api.get("/blog/admin/status").then((r) => r.data);

export const adminGetBlogSettings = () =>
  api.get("/blog/admin/settings").then((r) => r.data);

export const adminSaveBlogSettings = (posts_per_week, categories) =>
  api.put("/blog/admin/settings", { posts_per_week, categories }).then((r) => r.data);

export const adminCreatePost = (payload) =>
  api.post("/blog/admin/posts", payload).then((r) => r.data);

export const adminUpdatePost = (id, payload) =>
  api.put(`/blog/admin/posts/${id}`, payload).then((r) => r.data);

export const adminGetPost = (id) =>
  api.get(`/blog/admin/posts/${id}`).then((r) => r.data);

export const adminGetResearchBrief = (articleId) =>
  api.get(`/admin/v2/seo-opportunities/research-brief/by-article/${articleId}`).then((r) => r.data);

export const adminStartResearch = (opportunityId) =>
  api.post(`/admin/v2/seo-opportunities/opportunity/${opportunityId}/start-research`).then((r) => r.data);

export const adminRefreshPaa = (articleId) =>
  api.post(`/admin/v2/seo-opportunities/research-brief/by-article/${articleId}/refresh-paa`).then((r) => r.data);

export const adminPublishBlog = (id) =>
  api.post(`/blog/admin/${id}/publish`).then((r) => r.data);

export const adminUnpublishBlog = (id) =>
  api.post(`/blog/admin/${id}/unpublish`).then((r) => r.data);

export const adminDeleteBlog = (id) =>
  api.delete(`/blog/admin/${id}`).then((r) => r.data);
